export class ResetOrderLastVisitedStep {
  public static readonly type = '[Order Last Visited Step] Reset Order Last Visited Step';
}
